/**
 * Home page data including tips and other static content
 */
export const homeData = {
  tips: [
    "Make sure to double-check the GCash reference number before submitting.",
    "Take a clear photo of your payment proof for faster processing.",
    "Your subscription will be activated once payment is confirmed.",
    "You can activate your subscription anytime after purchase.",
    "Contact support if you encounter any issues during purchase.",
    "Check your email for purchase confirmation after payment.",
    "Your subscription duration starts when you activate it.",
    "Keep your payment proof until your subscription is confirmed."
  ]
};

